"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useJkRoomsCountSelectorProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _analytics = require("../../../../analytics");
var _selectors = require("../../../../selectors");
var _useActions = require("../useActions");
var _jkRoomsCountSelectorOptions = require("../../../../constants/jkRoomsCountSelectorOptions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Пропсы для фильтра выбора комнатности */
const useJkRoomsCountSelectorProps = () => {
  const {
    jkRoomsCount,
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setJkRooms
  } = (0, _useActions.useActions)();
  const onValueChange = React.useCallback(value => {
    let nextValue = null;
    if (value !== _jkRoomsCountSelectorOptions.ALL && jkRoomsCount !== value) {
      nextValue = value;
    }
    setJkRooms({
      jkRoomsCount: nextValue
    });
    (0, _analytics.trackRoomsCountClick)(estimationTarget);
  }, [setJkRooms, jkRoomsCount, estimationTarget]);
  return {
    value: jkRoomsCount || _jkRoomsCountSelectorOptions.ALL,
    onValueChange,
    values: _jkRoomsCountSelectorOptions.jkRoomsCountSelectorOptions,
    placeholder: 'Любая комнатность',
    //TODO убрать из типизации, т.к поле необязательно
    errorMessage: ''
  };
};
exports.useJkRoomsCountSelectorProps = useJkRoomsCountSelectorProps;